var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav',{staticClass:"footer",attrs:{"fixed":"bottom"}},[_c('b-nav-item',{staticClass:"footer-item",attrs:{"href":_vm.$props.url}},[_c('b',[_vm._v(_vm._s(_vm.$props.name))]),_vm._v(" - "+_vm._s(_vm.$props.slogan))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }